"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Brush;

var _Brush = require("@adobe/react-spectrum-workflow/dist/Brush");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Brush(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Brush.A4uBrush, null));
}